import { render, staticRenderFns } from "./index.vue?vue&type=template&id=33af7eda&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=33af7eda&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33af7eda",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\aihuz\\arbitration-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33af7eda')) {
      api.createRecord('33af7eda', component.options)
    } else {
      api.reload('33af7eda', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=33af7eda&scoped=true&", function () {
      api.rerender('33af7eda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/case/prove/index.vue"
export default component.exports